module.exports = __webpack_public_path__ + "static/media/corporate-services-img62.ed47cdfe.jpg";